<template>
  <div class="brand-container">
    <!-- 面包屑 -->
    <div class="breadcrumb-wrapper">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/Welcome' }">
          <i class="el-icon-s-home"></i> 首页
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <i class="el-icon-tickets"></i> 商标管理
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 统计卡片 -->
    <div class="stat-cards">
      <el-card class="stat-card" shadow="hover" @click.native="filterStatus('all')">
        <div class="stat-content">
          <div class="stat-icon total"><i class="el-icon-tickets"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ totalCount }}</div>
            <div class="stat-label">全部商标</div>
          </div>
          <div class="stat-trend"><i class="el-icon-top"></i> 12%</div>
        </div>
      </el-card>
      <el-card class="stat-card" shadow="hover" @click.native="filterStatus('pending')">
        <div class="stat-content">
          <div class="stat-icon pending"><i class="el-icon-time"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ pendingCount }}</div>
            <div class="stat-label">待审核</div>
          </div>
          <div class="stat-trend"><i class="el-icon-bottom"></i> 5%</div>
        </div>
      </el-card>
      <el-card class="stat-card" shadow="hover" @click.native="filterStatus('approved')">
        <div class="stat-content">
          <div class="stat-icon approved"><i class="el-icon-check"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ approvedCount }}</div>
            <div class="stat-label">已通过</div>
          </div>
          <div class="stat-trend"><i class="el-icon-top"></i> 8%</div>
        </div>
      </el-card>
      <el-card class="stat-card" shadow="hover" @click.native="filterStatus('rejected')">
        <div class="stat-content">
          <div class="stat-icon rejected"><i class="el-icon-close"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ rejectedCount }}</div>
            <div class="stat-label">已驳回</div>
          </div>
          <div class="stat-trend"><i class="el-icon-bottom"></i> 3%</div>
        </div>
      </el-card>
    </div>

    <!-- 主体卡片 -->
    <el-card class="main-card" shadow="never">
      <!-- 搜索栏 -->
      <div class="search-bar">
        <el-form :model="searchForm" size="mini" label-width="80px" label-position="right" @submit.native.prevent>
          <el-row :gutter="16">
            <el-col :xs="24" :sm="12" :md="8" :lg="6">
              <el-form-item label="商标名称">
                <el-input v-model="searchForm.name" placeholder="请输入名称" prefix-icon="el-icon-search" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="6">
              <el-form-item label="注册号">
                <el-input v-model="searchForm.regSn" placeholder="请输入注册号" prefix-icon="el-icon-document" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="6">
              <el-form-item label="商标类型">
                <el-select v-model="searchForm.brandType" placeholder="请选择类型" clearable>
                  <el-option label="国内" :value="1"></el-option>
                  <el-option label="单一国外" :value="2"></el-option>
                  <el-option label="马德里国际" :value="3"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="6">
              <el-form-item label="审核状态">
                <el-select v-model="searchForm.status" placeholder="请选择状态" clearable>
                  <el-option label="待审核" :value="0"></el-option>
                  <el-option label="已通过" :value="1"></el-option>
                  <el-option label="已驳回" :value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :xs="24" :sm="12" :md="8" :lg="6">
              <el-form-item label="申请日期">
                <el-date-picker
                  v-model="dateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始"
                  end-placeholder="结束"
                  value-format="yyyy-MM-dd"
                  style="width: 100%;"
                  @change="handleDateRangeChange"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="6">
              <el-form-item  label="有效期至">
                <el-date-picker
                  v-model="expireRange"
                  type="daterange"
                  size="mini"
                  range-separator="至"
                  start-placeholder="开始"
                  end-placeholder="结束"
                  value-format="yyyy-MM-dd"
                  style="width: 100%;"
                  @change="handleExpireRangeChange"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="6">
              <el-form-item label="所属行业">
                <el-cascader
                size="mini"
                  v-model="industryList"
                  :props="industryProps"
                  :options="industryOptions"
                  placeholder="请选择"
                  clearable
                  filterable
                  style="width: 100%;"
                  @change="handleIndustryChange"
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="6" class="search-actions">
              <el-button type="primary" size="mini" @click="searchSubmit" icon="el-icon-search">搜索</el-button>
              <el-button @click="resetSearch" size="mini" icon="el-icon-refresh-right">重置</el-button>
              <el-button type="success" size="mini" @click="addData" icon="el-icon-plus">新增</el-button>
              <el-dropdown trigger="click" size="mini" @command="handleExportCommand" split-button type="warning" icon="el-icon-download">
                导出
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="selected">导出选中（已选{{ multipleSelection.length }}条）</el-dropdown-item>
                  <el-dropdown-item command="all">导出全部数据</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-col>
          </el-row>
        </el-form>
        <!-- 选中条数提示 -->
        <div v-if="multipleSelection.length > 0" class="select-tip">
          <i class="el-icon-check"></i> 当前已选中 <span style="color:#1677ff; font-weight:bold">{{ multipleSelection.length }}</span> 条数据，可批量导出
        </div>
      </div>

      <!-- 表格 -->
      <div class="table-wrapper" v-loading="loading" element-loading-text="数据加载中...">
        <el-table
          ref="multipleTable"
          :data="tableLoadData"
          stripe
          border
          size="medium"
          row-key="id"
          :header-cell-style="headerCellStyle"
          @sort-change="handleSortChange"
          @selection-change="handleSelectionChange"
        >
          <!-- 多选框列 -->
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          
          <el-table-column type="index" label="序号" width="55" align="center" :index="indexMethod"></el-table-column>
          
          <el-table-column label="商标图样" width="80" align="center">
            <template slot-scope="scope">
              <el-image
                v-if="scope.row.img_url"
                :src="scope.row.img_url"
                fit="cover"
                style="width: 40px; height: 40px; border-radius: 8px;"
                :preview-src-list="[scope.row.img_url]"
              ></el-image>
              <div v-else class="no-image"><i class="el-icon-picture-outline"></i></div>
            </template>
          </el-table-column>

          <el-table-column label="H5二维码" width="100" align="center">
            <template slot-scope="scope">
              <el-image
                style="width:60px; height:60px; border-radius:4px; cursor:pointer;"
                :src="getQrUrl(scope.row)"
                :preview-src-list="[getQrUrl(scope.row)]"
                fit="contain"
                @click="previewQr(scope.row)"
              ></el-image>
              <div style="font-size:11px; color:#909399; margin-top:2px;">扫码查看</div>
            </template>
          </el-table-column>

          <el-table-column label="商标信息" min-width="180">
            <template slot-scope="scope">
              <div class="shop-info">
                <div class="shop-name"><span>{{ scope.row.name || '-' }}</span></div>
                <div class="shop-sn">注册号：<span>{{ scope.row.reg_sn || '-' }}</span></div>
                <div class="shop-type">
                  <el-tag size="mini" type="info" v-if="scope.row.brand_type == 1">国内</el-tag>
                  <el-tag size="mini" type="warning" v-else-if="scope.row.brand_type == 2">单一国外</el-tag>
                  <el-tag size="mini" type="danger" v-else-if="scope.row.brand_type == 3">马德里</el-tag>
                </div>
              </div>
            </template>
          </el-table-column>

         <el-table-column label="类别" width="120" align="center">
  <template slot-scope="scope">
    <el-tooltip 
      :content="scope.row.category_name || '-'" 
      placement="top" 
      effect="dark"
      popper-append-to-body
    >
      <div class="category-text">{{ scope.row.category_name || '-' }}</div>
    </el-tooltip>
  </template>
</el-table-column>

          <el-table-column label="联系人" width="140" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.cont_name || '-' }}</div>
              <div style="font-size:12px; color:#909399;">{{ scope.row.telephone || '-' }}</div>
            </template>
          </el-table-column>

          <el-table-column label="申请日期" width="120" align="center" prop="apply_date" sortable="custom">
            <template slot-scope="scope">{{ scope.row.apply_date || '-' }}</template>
          </el-table-column>

          <el-table-column label="有效期至" width="120" align="center" prop="expire_date" sortable="custom">
            <template slot-scope="scope">{{ scope.row.expire_date || '-' }}</template>
          </el-table-column>

          <el-table-column label="状态" width="100" align="center">
            <template slot-scope="scope">
              <el-tag :type="getStatusType(scope.row.status)" size="small" effect="plain" @click="handleStatusClick(scope.row)">
                {{ getStatusText(scope.row.status) }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="180" align="center" fixed="right">
            <template slot-scope="scope">
              <el-dropdown trigger="click" @command="handleCommand($event, scope.row)">
                <el-button type="primary" size="small" plain>
                  操作 <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="view"><i class="el-icon-view"></i> 查看</el-dropdown-item>
                  <el-dropdown-item command="edit"><i class="el-icon-edit"></i> 修改</el-dropdown-item>
                  <el-dropdown-item command="auth" v-if="scope.row.status == 0"><i class="el-icon-check"></i> 审核</el-dropdown-item>
                  <el-dropdown-item command="copy"><i class="el-icon-document-copy"></i> 复制</el-dropdown-item>
                  <el-dropdown-item command="share"><i class="el-icon-share"></i> 分享链接</el-dropdown-item>
                  <el-dropdown-item command="del" divided><i class="el-icon-delete" style="color:#ff4d4f;"></i> 删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination-wrapper">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>

        <!-- 空状态 -->
        <div v-if="tableLoadData.length === 0 && !loading" class="empty-state">
          <i class="el-icon-tickets"></i>
          <p>暂无商标数据</p>
          <el-button type="primary" size="small" @click="addData">立即添加</el-button>
        </div>
      </div>
    </el-card>

    <!-- 审核对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogFormVisible"
      width="480px"
      :close-on-click-modal="false"
      class="brand-dialog"
      @closed="handleDialogClosed"
    >
      <el-form :model="form" :rules="rules" ref="form" label-width="100px" label-position="right">
        <el-form-item label="商标名称">
          <el-input v-model="form.name" disabled></el-input>
        </el-form-item>
        <el-form-item label="审核状态" prop="status">
          <el-select v-model="form.status" placeholder="请选择审核状态" style="width:100%;">
            <el-option label="已通过" :value="1">
              <span style="color:#00b578;">● 已通过</span>
            </el-option>
            <el-option label="驳回" :value="2">
              <span style="color:#ff4d4f;">● 驳回</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审核备注" prop="remark" v-if="form.status == 2">
          <el-input v-model="form.remark" type="textarea" rows="3" placeholder="请输入驳回原因" maxlength="200" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="审核备注" v-else>
          <el-input v-model="form.remark" type="textarea" rows="3" placeholder="选填审核意见" maxlength="200" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">确认审核</el-button>
      </div>
    </el-dialog>

    <!-- 商标资料弹窗 -->
    <el-dialog :title="fileTitle" :visible.sync="fileDialogVisible" width="600px" class="brand-dialog">
      <div style="padding:20px; text-align:center;">
        <el-image
          v-if="fileImage"
          :src="fileImage"
          fit="contain"
          style="width:100%; max-height:400px;"
          :preview-src-list="[fileImage]"
        ></el-image>
        <div v-else style="color:#909399; padding:40px 0;">
          <i class="el-icon-picture-outline" style="font-size:48px;"></i>
          <p>暂无商标图片资料</p>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="fileDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'BrandList',
  data() {
    return {
      loading: false,
      // 多选选中数组
      multipleSelection: [],
      // 统计
      totalCount: 0,
      pendingCount: 0,
      approvedCount: 0,
      rejectedCount: 0,
      // 搜索表单
      searchForm: {
        name: '',
        regSn: '',
        brandType: '',
        status: '',
        industryId: '',
        applyStart: '',
        applyEnd: '',
        expireStart: '',
        expireEnd: ''
      },
      dateRange: [],
      expireRange: [],
      industryList: [],
      industryProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        checkStrictly: true
      },
      industryOptions: [],
      // 表格数据
      tableLoadData: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      // 审核对话框
      dialogFormVisible: false,
      dialogTitle: '商标审核',
      form: {
        id: '',
        name: '',
        status: 1,
        remark: ''
      },
      rules: {
        status: [{ required: true, message: '请选择审核状态', trigger: 'change' }],
        remark: [{ required: true, message: '请输入驳回原因', trigger: 'blur' }]
      },
      // 资料弹窗
      fileDialogVisible: false,
      fileTitle: '',
      fileImage: ''
    }
  },
  created() {
    this.getIndustryList()
    this.getDataList()
  },
  methods: {
    // 表格多选事件
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 导出下拉菜单指令
    handleExportCommand(cmd) {
      if (cmd === 'selected') {
        if (!this.multipleSelection.length) {
          return this.$message.warning('请先勾选需要导出的数据！')
        }
        this.exportSelected()
      } else if (cmd === 'all') {
        this.exportAll()
      }
    },
    // 导出选中项
    exportSelected() {
      const ids = this.multipleSelection.map(item => item.id)
      this.$message.success(`已提交导出任务，选中${ids.length}条商标数据`)
      // 此处替换真实导出接口，传ids批量导出
    },
    // 导出全部筛选后数据
    exportAll() {
      this.$message.success('已提交全部筛选数据导出任务，请稍后查看下载')
      // 此处替换真实全量导出接口，传searchForm筛选条件
    },
    getQrUrl(row) {
      // 替换为你的实际H5详情页地址
      const baseUrl = 'https://m.yourdomain.com/brandDetail'
      const url = `${baseUrl}?id=${row.id}`
      const encoded = encodeURIComponent(url)
      return `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encoded}`
    },
    headerCellStyle() {
      return { background: '#f7f9fc', color: '#2c3e50', fontWeight: '600', fontSize: '13px', borderBottom: '1px solid #e8ecf1' }
    },
    getStatusType(status) {
      const map = { 0: 'warning', 1: 'success', 2: 'danger' }
      return map[status] || 'info'
    },
    getStatusText(status) {
      const map = { 0: '待审核', 1: '已通过', 2: '已驳回' }
      return map[status] || '未知'
    },
    // 统计卡片点击筛选
    filterStatus(type) {
      if (type === 'all') this.searchForm.status = ''
      else if (type === 'pending') this.searchForm.status = 0
      else if (type === 'approved') this.searchForm.status = 1
      else if (type === 'rejected') this.searchForm.status = 2
      this.searchSubmit()
    },
    // 日期范围变化
    handleDateRangeChange(val) {
      if (val && val.length === 2) {
        this.searchForm.applyStart = val[0]
        this.searchForm.applyEnd = val[1]
      } else {
        this.searchForm.applyStart = ''
        this.searchForm.applyEnd = ''
      }
    },
    handleExpireRangeChange(val) {
      if (val && val.length === 2) {
        this.searchForm.expireStart = val[0]
        this.searchForm.expireEnd = val[1]
      } else {
        this.searchForm.expireStart = ''
        this.searchForm.expireEnd = ''
      }
    },
    handleIndustryChange(value) {
      this.searchForm.industryId = value && value.length ? value[value.length - 1] : ''
    },
    // 模拟获取行业树
    getIndustryList() {
      this.industryOptions = [
        { id: 1, name: '互联网/IT', children: [{ id: 11, name: '软件开发' }, { id: 12, name: '电商平台' }] },
        { id: 2, name: '实体商贸', children: [{ id: 21, name: '服装零售' }, { id: 22, name: '餐饮服务' }] },
        { id: 3, name: '制造业', children: [{ id: 31, name: '机械设备' }, { id: 32, name: '电子产品' }] }
      ]
    },
    // 表格序号
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    // 获取列表（模拟接口）
   async getDataList() {
  // 切换列表清空选中
  this.multipleSelection = []
  this.$refs.multipleTable?.clearSelection()
  this.loading = true
  try {
    const token = sessionStorage.getItem('token')
    const cid = sessionStorage.getItem('company_id')
    // 组装完整请求参数，匹配后端findListP接口
    let param = {
      access_token: token,
      company_id: cid,
      pageNum: this.pageNum,
      pageSize: this.pageSize,
      // 搜索条件
      name: this.searchForm.name,
      regSn: this.searchForm.regSn,
      brandType: this.searchForm.brandType,
      status: this.searchForm.status,
      industryId: this.searchForm.industryId,
      applyStart: this.searchForm.applyStart,
      applyEnd: this.searchForm.applyEnd,
      expireStart: this.searchForm.expireStart,
      expireEnd: this.searchForm.expireEnd,
      // 排序
      prop: this.sortProp || '',
      order: this.sortOrder || ''
    }
    // 请求后端分页接口
    let rs = await this.$axios.findBrandListP(param);
    if (rs.code == 200) {
      const resData = rs.data
      // 表格列表、分页总数
      this.tableLoadData = resData.list
      this.total = resData.total
      // 顶部统计卡片数据（后端返回，无需前端计算）
      this.totalCount = resData.totalCount
      this.pendingCount = resData.pendingCount
      this.approvedCount = resData.approvedCount
      this.rejectedCount = resData.rejectedCount
    }
  } catch (err) {
    console.error('获取商标列表失败', err)
    this.$message.error('数据加载失败，请稍后重试')
  } finally {
    this.loading = false
  }
},
    // 搜索
    searchSubmit() {
      this.pageNum = 1
      this.getDataList()
    },
    // 重置
    resetSearch() {
      this.searchForm = { name: '', regSn: '', brandType: '', status: '', industryId: '', applyStart: '', applyEnd: '', expireStart: '', expireEnd: '' }
      this.dateRange = []
      this.expireRange = []
      this.industryList = []
      this.searchSubmit()
    },
    // 新增
    addData() {
      this.$router.push('/brandForm')
    },
    // 分页切换
    handleSizeChange(val) {
      this.pageSize = val
      this.getDataList()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getDataList()
    },
    // 排序
    handleSortChange({ prop, order }) {
      // 模拟排序，实际应由后端处理
      if (prop === 'apply_date' || prop === 'expire_date') {
        this.tableLoadData.sort((a, b) => {
          const va = a[prop] || '', vb = b[prop] || ''
          return order === 'ascending' ? va.localeCompare(vb) : vb.localeCompare(va)
        })
        this.$forceUpdate()
      }
    },
    // 操作下拉
    handleCommand(command, row) {
      switch (command) {
        case 'view': this.goView(row); break
        case 'edit': this.goEdit(row); break
        case 'auth': this.goAuth(row); break
        case 'copy': this.copyRow(row); break
        case 'share': this.shareRow(row); break
        case 'del': this.delData(row); break
      }
    },
    goView(row) {
      this.$router.push({ path: '/brandInfo', query: { id: row.id } })
    },
    goEdit(row) {
      this.$router.push({ path: '/brandForm', query: { id: row.id } })
    },
    goAuth(row) {
      this.dialogTitle = `审核 - ${row.name}`
      this.form.id = row.id
      this.form.name = row.name
      this.form.status = 1 // 默认通过
      this.form.remark = ''
      this.dialogFormVisible = true
    },
    copyRow(row) {
      this.$message.success(`已复制商标 ${row.name}，请修改后保存`)
    },
    shareRow(row) {
      this.$message.success(`已生成分享链接：https://xxx.com/brand/${row.id}`)
    },
    goFile(row) {
      this.fileTitle = `${row.name} - 商标资料`
      this.fileImage = row.img_url || ''
      this.fileDialogVisible = true
    },
   async delData(row) {
  this.$confirm(`确定要删除商标“${row.name}”吗？此操作不可恢复。`, '删除确认', {
    confirmButtonText: '确定删除',
    cancelButtonText: '取消',
    type: 'error',
    confirmButtonClass: 'el-button--danger'
  }).then(async () => {
    try {
      const token = sessionStorage.getItem('token')
      const company_id = sessionStorage.getItem('company_id')
      const res = await this.$axios.brandDel({
        access_token: token,
        company_id: company_id,
        id: row.id
      })
      if (res.code === 200) {
        this.$message.success('删除成功')
        this.getDataList()
      } else {
        this.$message.error(res.msg || '删除失败')
      }
    } catch (err) {
      this.$message.error('请求异常，删除失败')
    }
  }).catch(() => {})
},
    // 审核提交
    submitForm() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        // 模拟审核逻辑
        const action = this.form.status === 1 ? '通过' : '驳回'
        this.$message.success(`商标“${this.form.name}”${action}成功`)
        this.dialogFormVisible = false
        this.getDataList()
      })
    },
    handleDialogClosed() {
      this.$refs.form?.resetFields()
    },
    // 点击状态标签可快速审核（待审核跳转）
    handleStatusClick(row) {
      if (row.status === 0) {
        this.goAuth(row)
      } else {
        this.$message.info(`当前状态：${this.getStatusText(row.status)}`)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.brand-container {
  padding: 20px;
  background: #f0f2f5;
  min-height: calc(100vh - 60px);
}
.breadcrumb-wrapper {
  margin-bottom: 20px;
  .el-breadcrumb {
    font-size: 14px;
    i { margin-right: 4px; color: #409eff; }
  }
}

/* 选中提示 */
.select-tip {
  margin-top: 10px;
  padding: 8px 14px;
  background: #e6f4ff;
  border-radius: 8px;
  color: #1677ff;
  font-size: 13px;
  i { margin-right: 6px; }
}

/* 统计卡片 */
.stat-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 20px;
}
.stat-card {
  border-radius: 16px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  }
  .stat-content {
    display: flex;
    align-items: center;
    padding: 6px 0;
  }
  .stat-icon {
    width: 48px;
    height: 48px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    color: #fff;
    margin-right: 16px;
    flex-shrink: 0;
    &.total { background: linear-gradient(135deg, #4f7cff, #7ca3ff); }
    &.pending { background: linear-gradient(135deg, #faad14, #ffd666); }
    &.approved { background: linear-gradient(135deg, #00b578, #4cd9a0); }
    &.rejected { background: linear-gradient(135deg, #ff4d4f, #ff7875); }
  }
  .stat-info {
    flex: 1;
    .stat-value { font-size: 28px; font-weight: 700; color: #1f2d3d; line-height: 1.2; }
    .stat-label { font-size: 14px; color: #8c8f98; margin-top: 2px; }
  }
  .stat-trend {
    font-size: 13px;
    color: #00b578;
    background: #e8f5e9;
    padding: 2px 10px;
    border-radius: 20px;
    i { margin-right: 2px; }
    &.down { color: #ff4d4f; background: #fde8e8; }
  }
}

/* 主体卡片 */
.main-card {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
  ::v-deep .el-card__body { padding: 20px 24px 24px; }
}

/* 搜索栏 */
.search-bar {
  background: #f8fafc;
  padding: 20px 20px 4px;
  border-radius: 12px;
  margin-bottom: 24px;
  .el-form-item { margin-bottom: 16px; width: 100%; }
  .el-form-item__label { font-weight: 500; font-size: 13px; color: #4a5568; }
  .el-input__inner, .el-select .el-input__inner, .el-cascader .el-input__inner {
    border-radius: 20px;
    height: 36px;
    line-height: 36px;
  }
  .search-actions {
    display: flex;
    gap: 10px;
    justify-content: flex-end;
    flex-wrap: wrap;
    .el-button {
      border-radius: 20px;
      padding: 8px 20px;
      font-weight: 500;
      &.el-button--primary { background: #1677ff; border-color: #1677ff; &:hover { background: #4096ff; } }
      &.el-button--success { background: #00b578; border-color: #00b578; &:hover { background: #1acd8c; } }
      &.el-button--warning { background: #faad14; border-color: #faad14; color: #fff; &:hover { background: #ffd666; } }
    }
  }
}

/* 表格 */
.table-wrapper {
  min-height: 400px;
  .el-table {
    border-radius: 12px;
    overflow: hidden;
    ::v-deep th { background: #f7f9fc !important; font-weight: 600; }
    ::v-deep .el-table__row:hover { background: #f5f9ff; }
  }
  .shop-info {
    .shop-name { font-weight: 600; font-size: 15px; color: #2c3e50; }
    .shop-sn { font-size: 12px; color: #8c8f98; margin-top: 2px; span { color: #1677ff; font-family: monospace; } }
    .shop-type { margin-top: 4px; }
  }
  .no-image {
    width: 40px; height: 40px; border-radius: 8px;
    background: #f0f2f5; display: flex; align-items: center; justify-content: center;
    font-size: 20px; color: #c0c4cc;
  }
  .empty-state {
    text-align: center; padding: 60px 0; color: #c0c4cc;
    i { font-size: 56px; }
    p { margin: 16px 0; font-size: 14px; }
    .el-button { border-radius: 20px; }
  }
}
.pagination-wrapper {
  margin-top: 20px;
  text-align: right;
  ::v-deep .el-pagination .el-pager li { border-radius: 6px; }
}

/* 对话框 */
.brand-dialog {
  ::v-deep .el-dialog {
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.12);
    .el-dialog__header {
      background: linear-gradient(135deg, #1677ff, #4096ff);
      padding: 18px 24px;
      .el-dialog__title { color: #fff; font-weight: 600; font-size: 17px; }
      .el-dialog__headerbtn .el-dialog__close { color: #fff; }
    }
    .el-dialog__body { padding: 24px 28px; }
    .el-dialog__footer {
      padding: 16px 28px 24px;
      border-top: 1px solid #f0f2f5;
    }
  }
  .dialog-footer {
    display: flex; justify-content: flex-end; gap: 12px;
    .el-button { border-radius: 24px; padding: 9px 28px; }
  }
}

.category-text {
  max-width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
}
</style>